import React, { useEffect, useState } from 'react';
import { Box, Button, FormControl, TablePagination, TextField, Typography } from '@material-ui/core';
import MaterialTable from 'material-table';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import Constants from '../../common/constants';
import { IsEmpty } from '../../common/checks';
import OverLoading from '../global/OverLoading';
import apiService from '../../services.js/apiService';

function HighlightList(props) {
  const [loading, setLoading] = useState(true);
  const [highlights, setHighlights] = useState([]);
  const [selectedHighlight, setSelectedHighlight] = useState({ id: null, title: null });
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [title, setTitle] = useState('');
  const [titleFocus, setTitleFocus] = React.useState(false);
  const [pageName, setPageName] = React.useState('');
  const [pageNameFocus, setPageNameFocus] = React.useState(false);
  const pageOptions = [5, 10, 15, 20, 25];
  const [id, setId] = React.useState(props.pageId);

  const fetchHighlights = async (params) => {
    try {
      const { rows, totalCount } = await apiService.getNonGroupPagesHighlights({ ...params, pageStatus: Constants.Status.Live });

      if (!IsEmpty(id)) {
        const selHighlight = await apiService.getHighlightByPageId(id);
        setSelectedHighlight({ id: selHighlight.id, title: selHighlight.title });
        const index = rows.findIndex((el) => el.pageId === id);
        if (index !== -1) {
          rows[index].tableData = { checked: true };
        }
      }

      setHighlights(rows || []);
      setPageCount(totalCount);
      setLoading(false);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleChangePage = async (e) => {
    setPageNo(e);
  };

  const handleChangeRowsPerPage = (e) => {
    setPageSize(e.target.value);
    setPageNo(0);
  };

  useEffect(() => {
    fetchHighlights({ pageNo, pageSize });
  }, [pageNo, pageSize]);

  useEffect(() => {
    setPageNo(0);
    fetchHighlights({ title, pageName, pageNo, pageSize });
  }, [title, pageName]);

  return (
    <>
      {loading && <OverLoading />}
      <MaterialTable
        columns={[
          { title: 'Id', field: 'id', width: '30px' },
          { title: 'Highlight Title', field: 'title', width: '30px' },
          { title: 'Page Name', field: 'pageName', width: '30px' },
        ]}
        isloading={loading}
        data={highlights}
        options={{
          actionsColumnIndex:    -1,
          search:                true,
          sorting:               true,
          paging:                true,
          emptyRowsWhenPaging:   false,
          selection:             true,
          pageSize:              pageOptions.slice(-1)[0],
          showSelectAllCheckbox: false,
          showTextRowsSelected:  false,
        }}
        onSelectionChange={(rows, selected) => {
          if (selected !== undefined) {
            rows.map((el) => {
              if (el.id !== selected.id) {
                el.tableData.checked = false;
              }
              return el;
            });
            if (selected.tableData.checked) {
              setId(selected.pageId);
              setSelectedHighlight({ id: selected.id, title: selected.title });
              props.onChangedPageId(selected.pageId);
            } else {
              setId(null);
              setSelectedHighlight({ id: null, title: null });
            }
          }
          return rows;
        }}
        components={{
          Pagination: (comProps) => (
            <TablePagination
              classes={comProps.classes}
              icon={comProps.icon}
              style={comProps.style}
              labelRowsPerPage={comProps.labelRowsPerPage}
              labelDisplayedRows={comProps.labelDisplayedRows}
              ActionsComponent={comProps.ActionsComponent}
              SelectProps={comProps.SelectProps}
              page={pageNo}
              onChangePage={(e, page) => {
                handleChangePage(page);
              }}
              onChangeRowsPerPage={(e) => {
                handleChangeRowsPerPage(e);
              }}
              rowsPerPageOptions={pageOptions}
              rowsPerPage={pageSize}
              count={pageCount}
            />
          ),
          Toolbar: () => (
            <div>
              <div>
                <Typography variant="h6" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Highlight List</Typography>
              </div>
              <div className="pt-3 pl-2" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Box p={1} width={{ xs: '35%', md: '20%', xl: '20%' }} whiteSpace="nowrap">
                  <FormControl fullWidth>
                    <TextField
                      label="Page Name"
                      value={pageName}
                      onChange={(e) => {
                        setPageName(e.target.value);
                        setTitleFocus(false);
                        setPageNameFocus(true);
                      }}
                      autoFocus={pageNameFocus}
                    />
                  </FormControl>
                </Box>
                <Box p={1} width={{ xs: '35%', md: '20%' }}>
                  <FormControl fullWidth>
                    <TextField
                      label="Highlight Title"
                      value={title}
                      onChange={(e) => {
                        setTitle(e.target.value);
                        setPageNameFocus(false);
                        setTitleFocus(true);
                      }}
                      autoFocus={titleFocus}
                    />
                  </FormControl>
                </Box>
              </div>
            </div>
          ),
        }}
      />
      <div
        className="row"
        style={{
          justifyContent: 'space-between',
          marginTop:      30,
          marginLeft:     0,
          marginRight:    0,
        }}
      >
        <div>
          <div className="row" style={{ marginLeft: 0, fontSize: 16 }}>
            Highlight selected ID:
            {' '}
            {selectedHighlight.id}
          </div>
          <div className="row" style={{ marginLeft: 0, fontSize: 16 }}>
            Highlight selected title:
            {' '}
            {selectedHighlight.title}
          </div>
        </div>
        <Button
          disabled={!!(id === null || id === '')}
          onClick={() => { props.onActiveStepChanged(props.activeStep + 1); }}
          variant="contained"
          color="default"
        >
          Next
        </Button>
      </div>
    </>
  );
}

HighlightList.propTypes = {
  pageId:              PropTypes.number.isRequired,
  onActiveStepChanged: PropTypes.func.isRequired,
  activeStep:          PropTypes.number.isRequired,
  onChangedPageId:     PropTypes.func.isRequired,
};

export default connect(null, null)(HighlightList);
